<template>
    <v-card>
        <v-card-title>
            <span class="text-h5">{{ formTitle }}</span>
        </v-card-title>

        <!-- Edited users-->
        <v-card-text>
            <v-form v-model="isValid">
                <v-container class="py-0">
                    <v-row>
                        <v-col
                            cols="12"
                            md="12"
                        >
                            <v-text-field
                                v-model="editedItem.title.value"
                                class="purple-input"
                                :label="$t('admin.posts.titleAtt')"
                                :error-messages="editedItem.title.error"
                                :rules="[rules.required]"
                                :disabled="isOnlyView"
                                @keyup="editedItem.title.error = ''"
                            />
                        </v-col>

                        <v-col
                            cols="12"
                            md="12"
                        >
                            <v-text-field
                                v-model="editedItem.title2.value"
                                class="purple-input"
                                :label="$t('admin.posts.titleAtt2')"
                                :error-messages="editedItem.title2.error"
                                :disabled="isOnlyView"
                                @keyup="editedItem.title2.error = ''"
                            />
                        </v-col>

                        <v-col
                            cols="12"
                            md="5"
                            lg="4"
                            sm="6"
                        >
                            <v-file-input
                                v-model="editedItem.img.value"
                                :label="$t('admin.posts.image')"
                                accept="image/*"
                                :error-messages="editedItem.img.error"
                                :rules="[rules.requiredAtLeastOne]"
                                :disabled="isOnlyView"
                                @change="preview_img"
                            />
                            <v-img
                                class="img_preview"
                                :src="editedItem.img.url"
                            />
                        </v-col>

                        <v-spacer/>

                        <v-col
                            cols="12"
                            md="5"
                            lg="4"
                            sm="6"
                        >
                            <v-file-input
                                v-model="editedItem.img2.value"
                                :label="$t('admin.posts.image2')"
                                accept="image/*"
                                :error-messages="editedItem.img2.error"
                                :disabled="isOnlyView"
                                @change="preview_img2"
                            />
                            <v-img
                                class="img_preview2"
                                :src="editedItem.img2.url"
                            />
                        </v-col>

                        <v-spacer/>

                        <v-col
                            cols="12"
                            md="5"
                            lg="4"
                            sm="6"
                        >
                            <v-text-field
                                v-model="editedItem.url.value"
                                class="purple-input"
                                :label="$t('admin.posts.url')"
                                :error-messages="editedItem.url.error"
                                :disabled="isOnlyView"
                                @keyup="editedItem.url.error = ''"
                            />
                        </v-col>

                        <v-col
                            sm="4"
                            md="3"
                            lg="2"
                        >
                            <v-switch
                                :disabled="isOnlyView"
                                v-model="editedItem.visualizePost"
                                inset
                                :label="$t('admin.posts.available')"
                            />

                        </v-col>

                        <v-col
                            cols="12"
                            md="5"
                            lg="4"
                            sm="6"
                        >

                            <v-text-field
                                v-model="editedItem.order.value"
                                class="purple-input"
                                :label="$t('admin.posts.order')"
                                :error-messages="editedItem.order.error"
                                :rules="[validOrder]"
                                :disabled="isOnlyView || !editedItem.visualizePost"
                                @keyup="editedItem.order.error = ''"
                                type="number"
                            />
                        </v-col>

                        <v-col
                            cols="12"
                            md="5"
                            lg="4"
                            sm="6"
                        >
                            <v-select
                                v-model="editedItem.lang.value"
                                :error-messages="editedItem.lang.error"
                                :items="[{id: 'es', name: 'Español'}, {id: 'en', name: 'Ingles'}]"
                                attach
                                :label="$t('admin.posts.lang')"
                                item-text="name"
                                item-value="id"
                                :rules="[rules.required]"
                                :disabled="isOnlyView"
                                @change="editedItem.lang.error = ''"
                            />

                            <!--                            <v-text-field
                                v-model="editedItem.lang.value"
                                class="purple-input"
                                :label="$t('admin.posts.lang')"
                                :error-messages="editedItem.lang.error"
                                :rules="[rules.required]"
                                :disabled="isOnlyView"
                                @keyup="editedItem.lang.error = ''"
                            />-->
                        </v-col>

                        <v-col
                            v-if="isOnlyView"
                            class="py-5"
                            cols="12"
                        >
                            <label>{{ $t('admin.posts.pageBody') }}</label>
                            <div
                                class="ql-editor"
                                v-html="editedItem.body.value"
                            />
                        </v-col>

                        <v-col
                            v-else
                            cols="12"
                        >
                            <div
                                class="text-h6 d-flex justify-space-between"
                            >
                                <!--                                <span>{{ $t(`admin.posts.${editorVisual ? 'editorVisual' : 'editorCode'}`) }}</span>-->
                                <v-switch
                                    v-model="editorVisual"
                                    inset
                                    :label="$t('admin.posts.editorVisual')"
                                />

                                <v-btn
                                    class="mx-2 pb-0 mb-0 mt-4"
                                    fab
                                    dark
                                    color="primary"
                                    small
                                    @click="restoreBody"
                                >
                                    <v-icon dark>
                                        mdi-undo
                                    </v-icon>
                                </v-btn>
                            </div>

                            <!-- Lo que el saneador del servidor elimina al guardar, lo
                                 edite quien lo edite: solo queda en páginas antiguas. -->
                            <v-alert
                                v-if="hasLegacyCode"
                                type="warning"
                                dense
                                outlined
                                class="text-body-2"
                            >
                                {{ $t('admin.posts.legacyCode') }}
                            </v-alert>

                            <layout-editor
                                v-if="editorVisual"
                                v-model="editedItem.body.value"
                            />
                            <v-textarea
                                v-else
                                name="input-7-1"
                                :value="editedItem.body.value"
                                outlined
                                rows="15"
                                @change="editorCodeChanged($event)"
                            />

                            <!-- Imágenes y PDF para enlazar desde el código, sin tocar el
                                 public/ del front. En el editor visual se suben desde
                                 su propia barra. -->
                            <v-row v-if="!editorVisual">
                                <v-col
                                    cols="12"
                                    md="6"
                                >
                                    <v-file-input
                                        v-model="contentFile.value"
                                        :label="$t('admin.posts.contentFile')"
                                        accept="image/png,image/jpeg,image/gif,image/webp,application/pdf"
                                        prepend-icon="mdi-paperclip"
                                        show-size
                                        :loading="contentFile.uploading"
                                        :disabled="contentFile.uploading"
                                        :error-messages="contentFile.error"
                                        @change="uploadContentFile"
                                    />
                                </v-col>
                                <v-col
                                    v-if="contentFile.url"
                                    cols="12"
                                    md="6"
                                >
                                    <v-text-field
                                        :value="contentFile.url"
                                        :label="$t('admin.posts.contentFileUrl')"
                                        :hint="$t('admin.posts.contentFileHint')"
                                        persistent-hint
                                        readonly
                                        append-icon="mdi-content-copy"
                                        @focus="$event.target.select()"
                                        @click:append="copyContentFileUrl"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-container>
            </v-form>
        </v-card-text>

        <v-card-actions>
            <v-spacer/>

            <v-btn
                color="blue darken-1"
                text
                @click="$router.go(-1)"
            >
                {{ $t('common.confirmDialogCancel') }}
            </v-btn>
            <v-btn
                v-if="!isOnlyView"
                color="blue darken-1"
                text
                :disabled="!isValid && !serverCheck"
                @click="save"
            >
                {{ $t('common.dialogSave') }}
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import axios from '@/plugins/axios'
import rules from '@/helpers/rulesValidate'
import { appendRichText } from '@/helpers/richTextField'
import { errorMessageKey } from '@/helpers/apiError'
import {mapGetters} from 'vuex'
import { uploadEditorFile } from '@/helpers/editorFiles'
import LayoutEditor from '@/components/common/form/layoutEditor'
import i18n from "@/lang/lang";

export default {
    components: {LayoutEditor},
    data: function () {
        return {
            urlMain: process.env.VUE_APP_API_ENDPOINT + 'posts',
            rules: {
                ...rules
            },
            item: null,
            editedItem: this.getEditedItem(),
            isValid: true,
            serverCheck: false,
            isOnlyView: false,

            // El editor visual respeta el HTML tal cual (ver layoutEditor.vue),
            // así que es el de partida: quien edita no tiene por qué saber HTML.
            editorVisual: true,
            contentFile: {
                value: null,
                uploading: false,
                error: '',
                url: ''
            }
        }
    },
    computed: {
        formTitle() {
            if (this.item) {
                return this.isOnlyView ? this.$t('admin.posts.view') : this.$t('admin.posts.edit')
            } else return this.$t('admin.posts.new')
        },
        validOrder() {
            const number = this?.editedItem?.order?.value;
            return !(this?.editedItem?.visualizePost) || /^(\+|\d)[0-9]{0,}$/.test(number) || i18n.t("rules.number")
        },
        // <style>, id y on...= (los botones de vídeo de la portada) los quita el
        // saneador del servidor al guardar. Sobre el cuerpo GUARDADO: el aviso
        // tiene que seguir aunque ya se hayan borrado en el editor.
        hasLegacyCode() {
            return /<style|<[a-z][^>]*\s(id|on[a-z]+)\s*=/i.test(this.item?.attributes?.body ?? '')
        }
        // ...mapGetters(['role', 'cities'])
    },
    created() {
        // console.log(this.item);
        /* console.log('this.$route.params')
        console.log(this.$route.params) */
    },
    /* watch: {
        dialog(val) {
            if (val) {
                this.editedItem = this.getEditedItem()
            }
        }
    }, */
    mounted() {
        this.item = this.$route.params.item ?? null;
    },
    methods: {
        getImageRoute() {
            return process.env.VUE_APP_API_ENDPOINT + 'imagesSimple?filename=posts/images/';
        },
        getEditedItem() {
            const item = this.$route.params.item ?? null;
            /* console.log('******* item **********')
            console.log(item) */

            /* const file = new File(
                [item.attributes.image],
                item.attributes.image,
                {
                    type: "text/plain"
                }
            ); */

            var empty = !item

            return {
                id: empty ? '' : item.id,
                title: {
                    value: empty ? '' : item.attributes.title,
                    error: ''
                },
                title2: {
                    value: empty ? '' : item.attributes.title2,
                    error: ''
                },
                body: {
                    value: empty ? '' : item.attributes.body,
                    error: ''
                },
                visualizePost: empty ? true : (item.attributes.order ?? false),
                order: {
                    value: empty ? '' : item.attributes.order,
                    error: ''
                },
                lang: {
                    value: empty ? '' : item.attributes.lang,
                    error: ''
                },
                img: {
                    value: empty || !item.attributes.image ? [] : new File(
                        [item.attributes.image],
                        item.attributes.image,
                        {
                            type: "text/plain"
                        }
                    ),
                    error: "",
                    url: empty || !item.attributes.image ? ""
                        : this.getImageRoute() + item.attributes.image
                },
                img2: {
                    value: empty || !item.attributes.image2 ? [] : new File(
                        [item.attributes.image2],
                        item.attributes.image2,
                        {
                            type: "text/plain"
                        }
                    ),
                    error: "",
                    url: empty || !item.attributes.image2 ? ""
                        : this.getImageRoute() + item.attributes.image2
                },
                url: {
                    value: empty ? '' : item.attributes.url,
                    error: ''
                }
            }
        },
        preview_img() {
            if (this.editedItem.img.value && !(this.editedItem.img.value instanceof Array)) {
                this.editedItem.img.url = URL.createObjectURL(
                    this.editedItem.img.value
                );
            } else {
                this.editedItem.img.url = null;
                this.editedItem.img.value = [];
            }
        },
        preview_img2() {
            if (this.editedItem.img2.value && !(this.editedItem.img2.value instanceof Array)) {
                this.editedItem.img2.url = URL.createObjectURL(
                    this.editedItem.img2.value
                );
            } else {
                this.editedItem.img2.url = null;
                this.editedItem.img2.value = [];
            }
        },
        initialize() {

        },
        async save() {
            const formData = new FormData();
            formData.append("title", this.editedItem.title.value);
            formData.append("title2", this.editedItem.title2.value ?? '');
            // El cuerpo va como parte de fichero, no como campo: ver richTextField.js.
            appendRichText(formData, "body", this.editedItem.body.value);
            formData.append("lang", this.editedItem.lang.value);
            formData.append("image", this.editedItem.img.value);
            formData.append("image2", this.editedItem.img2.value);
            formData.append("url", this.editedItem.url.value);

            if (this.editedItem.visualizePost) {
                formData.append("order", this.editedItem.order.value);
            }

            let urlAppend = '';
            if (this.editedItem.id) {
                urlAppend = '/' + this.editedItem.id;

                // PATCH real + multipart no funciona: PHP solo parsea el cuerpo
                // multipart en POST, así que la petición llegaba SIN ningún campo y
                // PostsController@update respondía 400 "No se recibieron datos".
                // Editar una noticia no llegaba a guardar nunca. Se usa el method
                // spoofing de Laravel, igual que en términos y artículos.
                formData.append("_method", "PATCH");
            }

            try {
                const result = await axios({
                    method: 'POST',
                    url: this.urlMain + urlAppend,
                    data: formData,
                    headers: { "Content-Type": "multipart/form-data" }
                });

                if ([200, 201, 204].includes(result.status)) {
                    this.viewPost(result.data.post);
                    const actionMSG = this.editedItem.id ? 'updatedOK' : 'createdOK';
                    this.$store.dispatch('snackbar/success', this.$t('common.' + actionMSG));
                }
            } catch (error) {
                this.$store.dispatch('snackbar/error', this.$t(errorMessageKey(error)));
            }
        },
        viewPost(item) {
            this.isOnlyView = true;

            this.editedItem = {
                id: item.id,
                title: {
                    value: item.title,
                    error: ''
                },
                title2: {
                    value: item.title2,
                    error: ''
                },
                body: {
                    value: item.body,
                    error: ''
                },
                order: {
                    value: item.order,
                    error: ''
                },
                lang: {
                    value: item.lang,
                    error: ''
                },
                img: {
                    value: new File(
                        [item.image],
                        item.image,
                        {
                            type: "text/plain"
                        }
                    ),
                    error: "",
                    url: this.editedItem.img.url
                },
                img2: {
                    value: new File(
                        [item.image2],
                        item.image2,
                        {
                            type: "text/plain"
                        }
                    ),
                    error: "",
                    url: this.editedItem.img2.url
                },
                url: {
                    value: item.url,
                    error: ''
                }
            }
        },

        restoreBody() {
            try {
                this.editedItem.body.value = this.item.attributes.body
            } catch (e) {

            }
        },
        editorCodeChanged(element) {
            this.editedItem.body.value = element;
        },
        async uploadContentFile(file) {
            this.contentFile.error = '';
            this.contentFile.url = '';

            if (!(file instanceof File)) {
                return;
            }

            this.contentFile.uploading = true;
            try {
                this.contentFile.url = await uploadEditorFile(file);
            } catch (error) {
                this.contentFile.error = this.$t('admin.posts.contentFileError');
            } finally {
                this.contentFile.uploading = false;
            }
        },
        async copyContentFileUrl() {
            try {
                await navigator.clipboard.writeText(this.contentFile.url);
                this.$store.dispatch('snackbar/success', this.$t('admin.posts.contentFileCopied'));
            } catch (e) {
                // Sin permiso de portapapeles: el campo se selecciona al enfocarlo
                // y se puede copiar con Ctrl+C.
            }
        }
    }
}
</script>

<style>
/*iframe.ql-video {
  width: 500px !important;
  height: 500px !important;
}*/

.quill-editor iframe {
    pointer-events: none;
}

</style>
